export default __webpack_public_path__ + "static/media/IMG_012.10c470e7.jpg";